import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { Redo as RedoIcon } from '@bibliocommons/base-icons';

import BatchActionButton from '../../../shared/BatchActions/BatchActionButton/BatchActionButton';
import BatchAddToShelfButton from '../../../shared/BatchActions/BatchAddToShelfButton';

import './CheckedOutBatchActions.scss';

export default function CheckedOutBatchActions({ itemsForAction, handleBatchRenew, handleBatchAddToShelf }) {
  const renewItemsSelected = itemsForAction.get('renew', Immutable.List());
  const shelfItemsSelected = itemsForAction.get('addToShelf', Immutable.List());
  return (
    <div className="cp-checked-out-batch-actions">
      <BatchActionButton
        className="batch-renew-button"
        selectedItemCount={renewItemsSelected.size}
        handleClick={() => handleBatchRenew(renewItemsSelected)}>
        <RedoIcon />
        <FormattedMessage id="button_renew" />
      </BatchActionButton>

      <BatchAddToShelfButton
        selectedItemCount={shelfItemsSelected.size}
        handleClick={(shelfName) => handleBatchAddToShelf(shelfItemsSelected, shelfName)} />
    </div>
  );
}

CheckedOutBatchActions.propTypes = {
  itemsForAction: ImmutablePropTypes.map,
  handleBatchRenew: PropTypes.func,
  handleBatchAddToShelf: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutBatchActions/CheckedOutBatchActions.jsx